import styled from '@emotion/styled';
import { Formik } from 'formik';
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { generatePath, Link, useParams } from 'react-router-dom';

import { assessmentManagerCreateRoute } from 'App/common/routeLookup';
import FlexCenter from 'App/components/styles/FlexCenter';
import PageTitle from 'App/components/styles/PageTitle/PageTitle';
import TherigyLoadingSpinner from 'App/components/TherigyLoadingSpinner';
import { CheckboxField } from 'Shared/form/CheckboxField';
import AssessmentManagerTable from './AssessmentManagerTable/AssessmentManagerTable';
import AssessmentManagerTCSelect from './AssessmentManagerTCSelect';
import useFetchAssessmentCategories from './hooks/useFetchAssessmentCategories';

const FlexHeaderStyle = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
`;

const AssessmentManagerHome = () => {
    const { data: categories, isLoading } = useFetchAssessmentCategories();
    const { categoryId } = useParams();

    if (isLoading) {
        return (
            <FlexCenter style={{ flexGrow: 1 }}>
                <TherigyLoadingSpinner />
            </FlexCenter>
        );
    }

    return (
        <Formik
            initialValues={{
                category: categories.find((cat) => cat.id === categoryId),
                isShowRetired: false,
            }}
            onSubmit={() => {}}
        >
            {({ values }) => (
                <div style={{ padding: 20 }}>
                    <PageTitle style={{ padding: 0 }}>Assessment Manager</PageTitle>

                    <FlexHeaderStyle>
                        <AssessmentManagerTCSelect categories={categories} />

                        {values.category && (
                            <Link to={generatePath(assessmentManagerCreateRoute, { categoryId: values.category.id })}>
                                <Button variant="primary">
                                    <FaPlus /> Create Custom Assessment
                                </Button>
                            </Link>
                        )}
                    </FlexHeaderStyle>

                    <AssessmentManagerTable />

                    <CheckboxField label="Show Retired & Hidden Assessments" fieldName="isShowRetired" />
                </div>
            )}
        </Formik>
    );
};

export default AssessmentManagerHome;
